import { SelectableStudentLists } from '../models/Assignment';

/**
 * Whether the "students who have not completed any of the support skills" warning was part of this
 * flow. The warning and its "Do Not Include" shortcut live in the Paving the Way tab and render
 * whenever that tab has students, so having students there is what makes them available.
 *
 * Note this reports availability, not visibility: the tab view renders only the active tab, and
 * Paving the Way is not the one open by default, so a teacher who never opened it still counts.
 */
export const wasSupportSkillWarningShown = (studentsLists: SelectableStudentLists): boolean =>
  studentsLists.buildingFoundations.list.length > 0;
